// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"701e4330","408":"971e1228","588":"53a14181","725":"3d459758","750":"9b95d597","883":"41b9c42d","929":"dab4cb5b","980":"3a8e4336"}[chunkId] + ".chunk.js";
};